export function formatConsultantTypeLabel(type) {
  const raw = String(type || '').trim();
  if (!raw) return '';

  const upper = raw.toUpperCase();
  if (upper === 'C2C' || upper === 'CTC') return 'C2C';
  if (upper === '1099') return '1099';
  if (upper === 'FULLTIME' || upper === 'FULL-TIME' || upper === 'FULL TIME') return 'Full-Time';

  return raw;
}

export function resolveConsultantType(consultant, lookupList = []) {
  let type =
    consultant?.consultantType ||
    consultant?.consultant_type ||
    consultant?.type ||
    '';

  if (!type && consultant?.id && Array.isArray(lookupList) && lookupList.length > 0) {
    const match = lookupList.find((c) => String(c.id) === String(consultant.id));
    type =
      match?.consultantType ||
      match?.consultant_type ||
      match?.type ||
      '';
  }

  return type;
}

/** Tone slug aligned with Consultant Center side menu colors. */
export function getConsultantTypeTone(type) {
  const upper = String(type || '').trim().toUpperCase();
  if (upper === 'C2C' || upper === 'CTC') return 'c2c';
  if (upper === '1099') return '1099';
  if (upper === 'FULLTIME' || upper === 'FULL-TIME' || upper === 'FULL TIME') return 'fulltime';
  return 'other';
}

export function getConsultantTypeIcon(tone) {
  switch (tone) {
    case 'c2c':
      return 'bi bi-briefcase-fill';
    case '1099':
      return 'bi bi-person-badge-fill';
    case 'fulltime':
      return 'bi bi-person-fill';
    default:
      return 'bi bi-person';
  }
}

/** Display label for invoice consultant dropdown: "Name - Type" (legacy plain text). */
export function formatConsultantDropdownLabel(consultant, lookupList = []) {
  const name = String(consultant?.consultantName || consultant?.name || '').trim();
  const typeLabel = formatConsultantTypeLabel(resolveConsultantType(consultant, lookupList));

  if (!name) return typeLabel || 'Consultant';
  if (!typeLabel) return name;
  return `${name} - ${typeLabel}`;
}

/** Rich LabelDropdown option: name left, colored type text right (Consultant Center colors). */
export function buildConsultantDropdownOption(consultant, lookupList = []) {
  const name = String(consultant?.consultantName || consultant?.name || '').trim();
  const rawType = resolveConsultantType(consultant, lookupList);
  const typeLabel = formatConsultantTypeLabel(rawType);
  const tone = getConsultantTypeTone(rawType);

  return {
    value: String(consultant.id),
    label: name || 'Consultant',
    detail: typeLabel || undefined,
    detailTone: typeLabel ? tone : undefined,
    detailPlain: Boolean(typeLabel),
    tone,
    icon: getConsultantTypeIcon(tone),
  };
}
